"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenXmlListLevelOverride = void 0;
var character_properties_1 = require("../../../core/model/character/character-properties");
var list_level_1 = require("../../../core/model/numbering-lists/list-level");
var list_level_properties_1 = require("../../../core/model/numbering-lists/list-level-properties");
var paragraph_properties_1 = require("../../../core/model/paragraph/paragraph-properties");
var OpenXmlListLevelOverride = (function () {
    function OpenXmlListLevelOverride(documentModel) {
        this.documentModel = documentModel;
    }
    Object.defineProperty(OpenXmlListLevelOverride.prototype, "newStart", {
        get: function () { return this._newStart; },
        set: function (val) {
            this._newStart = val;
            this.overrideStart = true;
            if (this.level != null)
                this.applyStartOverride(this.level);
        },
        enumerable: false,
        configurable: true
    });
    OpenXmlListLevelOverride.prototype.getOverrideListLevel = function () {
        if (this.level == null) {
            this.level = new list_level_1.OverrideListLevel(this.documentModel, character_properties_1.MaskedCharacterProperties.createDefault(this.documentModel), paragraph_properties_1.MaskedParagraphProperties.createDefault(this.documentModel), new list_level_properties_1.ListLevelProperties());
            this.applyStartOverride(this.level);
        }
        return this.level;
    };
    OpenXmlListLevelOverride.prototype.getOverrideListLevelCore = function (originalLevel) {
        if (this.level != null)
            return this.level;
        else if (this.overrideStart) {
            originalLevel.overrideStart = true;
            originalLevel.setNewStart(this._newStart);
        }
        return originalLevel;
    };
    OpenXmlListLevelOverride.prototype.applyStartOverride = function (level) {
        var _this = this;
        if (this.overrideStart) {
            level.overrideStart = true;
            level.changeListLevelProperties(function (prop) { return prop.start = _this._newStart; });
        }
    };
    return OpenXmlListLevelOverride;
}());
exports.OpenXmlListLevelOverride = OpenXmlListLevelOverride;
